export default "__VITE_ASSET__BXq7h$9W__"